// extracted by mini-css-extract-plugin
export var resizer = "_fd-0";